// extracted by mini-css-extract-plugin
export default {"prefix":"PhoneNumberInput_prefix__6qOk6","phone":"PhoneNumberInput_phone__vCmAw"};